
import { Component, Vue } from 'vue-property-decorator'
import UserLogin from '@/views/login/UserLogin.vue'
import PhoneLogin from '@/views/login/PhoneLogin.vue'
import { postFetch } from '@/service/common'
import Cookie from 'js-cookie'
import { Action } from 'vuex-class'

@Component({
  components: {
    UserLogin,
    PhoneLogin,
  },
})
export default class Login extends Vue {
  @Action fetchUserInfo!: Function

  async doLogin(type: string, params: object, callback: Function) {
    try {
      const { code, msg, data }: any = await postFetch(type, params)
      if (code === 0 && data) {
        Cookie.set('userId', data.user_id)
        Cookie.set('accessToken', data.access_token)
        const {
          apply_status,
          tb_bind_status,
          bid_type,
          need_upgrade,
        } = await this.fetchUserInfo()
        this.$message.success('登录成功')
        if (apply_status === 8 && tb_bind_status !== 1 && bid_type !== 6) {
          // 历史用户
          this.$router.push('/authentication')
        } else if (need_upgrade === 1) {
          // 历史供应商认证升级
          this.$router.push('/authentication')
        } else {
          this.$router.push((this.$route.query.redirect as any) || '/')
        }
      } else {
        this.$message.error(msg)
      }
    } catch (error) {
      console.log(
        '🚀 ~ file: LoginContent.vue ~ line 115 ~ LoginContent ~ doLogin ~ error',
        error
      )
    }
    callback()
  }
}
